// [0] KV --------------------------------------
import lobby_kv_pc from "../images/common/subkv/subkv_lobby-pc.png";
import lobby_kv_tab from "../images/common/subkv/subkv_lobby-tab.png";
import lobby_kv_mo from "../images/common/subkv/subkv_lobby-mo.png";
import lobby_kv_title_pc from "../images/common/subkv/subkv_lobby_title-pc.png";
import lobby_kv_title_tab from "../images/common/subkv/subkv_lobby_title-tab.png";
import lobby_kv_title_mo from "../images/common/subkv/subkv_lobby_title-mo.png";

import lounge_kv_pc from "../images/common/subkv/subkv_lounge-pc.png";
import lounge_kv_tab from "../images/common/subkv/subkv_lounge-tab.png";
import lounge_kv_mo from "../images/common/subkv/subkv_lounge-mo.png";
import lounge_kv_title_pc from "../images/common/subkv/subkv_lounge_title-pc.png";
import lounge_kv_title_tab from "../images/common/subkv/subkv_lounge_title-tab.png";
import lounge_kv_title_mo from "../images/common/subkv/subkv_lounge_title-mo.png";

import privateroom_kv_pc from "../images/common/subkv/subkv_privateroom-pc.png";
import privateroom_kv_tab from "../images/common/subkv/subkv_privateroom-tab.png";
import privateroom_kv_mo from "../images/common/subkv/subkv_privateroom-mo.png";
import privateroom_kv_title_pc from "../images/common/subkv/subkv_privateroom_title-pc.png";
import privateroom_kv_title_tab from "../images/common/subkv/subkv_privateroom_title-tab.png";
import privateroom_kv_title_mo from "../images/common/subkv/subkv_privateroom_title-mo.png";

// [1] lobby --------------------------------------
// [1-1] closet
import closet_title from "../images/lobby/lobby_closet_title.png";
import closet_main_pc from "../images/lobby/lobby_closet_main-pc.png";
import closet_main_tab from "../images/lobby/lobby_closet_main-tab.png";
import closet_main_mo from "../images/lobby/lobby_closet_main-mo.png";
import closet_01_pc from "../images/lobby/lobby_closet_01-pc.png";
import closet_01_tab from "../images/lobby/lobby_closet_01-tab.png";
import closet_01_mo from "../images/lobby/lobby_closet_01-mo.png";
import closet_02_pc from "../images/lobby/lobby_closet_02-pc.png";
import closet_02_tab from "../images/lobby/lobby_closet_02-tab.png";
import closet_02_mo from "../images/lobby/lobby_closet_02-mo.png";
import closet_03_pc from "../images/lobby/lobby_closet_03-pc.png";
import closet_03_tab from "../images/lobby/lobby_closet_03-tab.png";
import closet_03_mo from "../images/lobby/lobby_closet_03-mo.png";
import closet_04_pc from "../images/lobby/lobby_closet_04-pc.png";
import closet_04_tab from "../images/lobby/lobby_closet_04-tab.png";
import closet_04_mo from "../images/lobby/lobby_closet_04-mo.png";
import closet_05_pc from "../images/lobby/lobby_closet_05-pc.png";
import closet_05_tab from "../images/lobby/lobby_closet_05-tab.png";
import closet_05_mo from "../images/lobby/lobby_closet_05-mo.png";
import closet_06_pc from "../images/lobby/lobby_closet_06-pc.png";
import closet_06_tab from "../images/lobby/lobby_closet_06-tab.png";
import closet_06_mo from "../images/lobby/lobby_closet_06-mo.png";
// [1-2] vast
import vast_title from "../images/lobby/lobby_vast_title.png";
import vast_main_pc from "../images/lobby/lobby_vast_main-pc.png";
import vast_main_tab from "../images/lobby/lobby_vast_main-tab.png";
import vast_main_mo from "../images/lobby/lobby_vast_main-mo.png";
import vast_01_pc from "../images/lobby/lobby_vast_01-pc.png";
import vast_01_tab from "../images/lobby/lobby_vast_01-tab.png";
import vast_01_mo from "../images/lobby/lobby_vast_01-mo.png";
import vast_02_pc from "../images/lobby/lobby_vast_02-pc.png";
import vast_02_tab from "../images/lobby/lobby_vast_02-tab.png";
import vast_02_mo from "../images/lobby/lobby_vast_02-mo.png";
import vast_03_pc from "../images/lobby/lobby_vast_03-pc.png";
import vast_03_tab from "../images/lobby/lobby_vast_03-tab.png";
import vast_03_mo from "../images/lobby/lobby_vast_03-mo.png";
import vast_04_pc from "../images/lobby/lobby_vast_04-pc.png";
import vast_04_tab from "../images/lobby/lobby_vast_04-tab.png";
import vast_04_mo from "../images/lobby/lobby_vast_04-mo.png";
import vast_05_pc from "../images/lobby/lobby_vast_05-pc.png";
import vast_05_tab from "../images/lobby/lobby_vast_05-tab.png";
import vast_05_mo from "../images/lobby/lobby_vast_05-mo.png";
import vast_06_pc from "../images/lobby/lobby_vast_06-pc.png";
import vast_06_tab from "../images/lobby/lobby_vast_06-tab.png";
import vast_06_mo from "../images/lobby/lobby_vast_06-mo.png";
// [1-3] tranquil
import tranquil_title from "../images/lobby/lobby_tranquil_title.png";
import tranquil_main_pc from "../images/lobby/lobby_tranquil_main-pc.png";
import tranquil_main_tab from "../images/lobby/lobby_tranquil_main-tab.png";
import tranquil_main_mo from "../images/lobby/lobby_tranquil_main-mo.png";
import tranquil_01_pc from "../images/lobby/lobby_tranquil_01-pc.png";
import tranquil_01_tab from "../images/lobby/lobby_tranquil_01-tab.png";
import tranquil_01_mo from "../images/lobby/lobby_tranquil_01-mo.png";
import tranquil_02_pc from "../images/lobby/lobby_tranquil_02-pc.png";
import tranquil_02_tab from "../images/lobby/lobby_tranquil_02-tab.png";
import tranquil_02_mo from "../images/lobby/lobby_tranquil_02-mo.png";
import tranquil_03_pc from "../images/lobby/lobby_tranquil_03-pc.png";
import tranquil_03_tab from "../images/lobby/lobby_tranquil_03-tab.png";
import tranquil_03_mo from "../images/lobby/lobby_tranquil_03-mo.png";
import tranquil_04_pc from "../images/lobby/lobby_tranquil_04-pc.png";
import tranquil_04_tab from "../images/lobby/lobby_tranquil_04-tab.png";
import tranquil_04_mo from "../images/lobby/lobby_tranquil_04-mo.png";
import tranquil_05_pc from "../images/lobby/lobby_tranquil_05-pc.png";
import tranquil_05_tab from "../images/lobby/lobby_tranquil_05-tab.png";
import tranquil_05_mo from "../images/lobby/lobby_tranquil_05-mo.png";
import tranquil_06_pc from "../images/lobby/lobby_tranquil_06-pc.png";
import tranquil_06_tab from "../images/lobby/lobby_tranquil_06-tab.png";
import tranquil_06_mo from "../images/lobby/lobby_tranquil_06-mo.png";

// ----------------------------------
// [2] lounge --------------------------------------
import haven_01_pc from "../images/lounge/lounge_haven_01-pc.png";
import haven_01_tab from "../images/lounge/lounge_haven_01-tab.png";
import haven_01_mo from "../images/lounge/lounge_haven_01-mo.png";
import haven_02_pc from "../images/lounge/lounge_haven_02-pc.png";
import haven_02_tab from "../images/lounge/lounge_haven_02-tab.png";
import haven_02_mo from "../images/lounge/lounge_haven_02-mo.png";

import daisy_01_pc from "../images/lounge/lounge_daisy_01-pc.png";
import daisy_01_tab from "../images/lounge/lounge_daisy_01-tab.png";
import daisy_01_mo from "../images/lounge/lounge_daisy_01-mo.png";
import daisy_02_pc from "../images/lounge/lounge_daisy_02-pc.png";
import daisy_02_tab from "../images/lounge/lounge_daisy_02-tab.png";
import daisy_02_mo from "../images/lounge/lounge_daisy_02-mo.png";

import sage_01_pc from "../images/lounge/lounge_sage_01-pc.png";
import sage_01_tab from "../images/lounge/lounge_sage_01-tab.png";
import sage_01_mo from "../images/lounge/lounge_sage_01-mo.png";
import sage_02_pc from "../images/lounge/lounge_sage_02-pc.png";
import sage_02_tab from "../images/lounge/lounge_sage_02-tab.png";
import sage_02_mo from "../images/lounge/lounge_sage_02-mo.png";

import aria_01_pc from "../images/lounge/lounge_aria_01-pc.png";
import aria_01_tab from "../images/lounge/lounge_aria_01-tab.png";
import aria_01_mo from "../images/lounge/lounge_aria_01-mo.png";
import aria_02_pc from "../images/lounge/lounge_aria_02-pc.png";
import aria_02_tab from "../images/lounge/lounge_aria_02-tab.png";
import aria_02_mo from "../images/lounge/lounge_aria_02-mo.png";

import ethereal_01_pc from "../images/lounge/lounge_ethereal_01-pc.png";
import ethereal_01_tab from "../images/lounge/lounge_ethereal_01-tab.png";
import ethereal_01_mo from "../images/lounge/lounge_ethereal_01-mo.png";
import ethereal_02_pc from "../images/lounge/lounge_ethereal_02-pc.png";
import ethereal_02_tab from "../images/lounge/lounge_ethereal_02-tab.png";
import ethereal_02_mo from "../images/lounge/lounge_ethereal_02-mo.png";

import elysium_01_pc from "../images/lounge/lounge_elysium_01-pc.png";
import elysium_01_tab from "../images/lounge/lounge_elysium_01-tab.png";
import elysium_01_mo from "../images/lounge/lounge_elysium_01-mo.png";
import elysium_02_pc from "../images/lounge/lounge_elysium_02-pc.png";
import elysium_02_tab from "../images/lounge/lounge_elysium_02-tab.png";
import elysium_02_mo from "../images/lounge/lounge_elysium_02-mo.png";

import lounge_relaxed from "../images/lounge/lounge_relaxed@2x.png";
import lounge_respectful from "../images/lounge/lounge_respectful@2x.png";
import lounge_honest from "../images/lounge/lounge_honest@2x.png";


// [2] privateroom --------------------------------------
import privateroom_01_pc from "../images/privateroom/privateroom_01-pc.png";
import privateroom_02_pc from "../images/privateroom/privateroom_02-pc.png";
import privateroom_03_pc from "../images/privateroom/privateroom_03-pc.png";
import privateroom_04_pc from "../images/privateroom/privateroom_04-pc.png";
import privateroom_05_pc from "../images/privateroom/privateroom_05-pc.png";
import privateroom_06_pc from "../images/privateroom/privateroom_06-pc.png";
import privateroom_07_pc from "../images/privateroom/privateroom_07-pc.png";

import privateroom_01_tab from "../images/privateroom/privateroom_01-tab.png";
import privateroom_02_tab from "../images/privateroom/privateroom_02-tab.png";
import privateroom_03_tab from "../images/privateroom/privateroom_03-tab.png";
import privateroom_04_tab from "../images/privateroom/privateroom_04-tab.png";
import privateroom_05_tab from "../images/privateroom/privateroom_05-tab.png";
import privateroom_06_tab from "../images/privateroom/privateroom_06-tab.png";
import privateroom_07_tab from "../images/privateroom/privateroom_07-tab.png";

import privateroom_01_mo from "../images/privateroom/privateroom_01-mo.png";
import privateroom_02_mo from "../images/privateroom/privateroom_02-mo.png";
import privateroom_03_mo from "../images/privateroom/privateroom_03-mo.png";
import privateroom_04_mo from "../images/privateroom/privateroom_04-mo.png";
import privateroom_05_mo from "../images/privateroom/privateroom_05-mo.png";
import privateroom_06_mo from "../images/privateroom/privateroom_06-mo.png";
import privateroom_07_mo from "../images/privateroom/privateroom_07-mo.png";

import privateroom_title_pc from "../images/privateroom/privateroom_title-pc.png";
import privateroom_title_tab from "../images/privateroom/privateroom_title-tab.png";
import privateroom_title_mo from "../images/privateroom/privateroom_title-mo.png";

import privateroom_calli_pc from "../images/privateroom/privateroom_04_calli-pc.png";
import privateroom_calli_tab from "../images/privateroom/privateroom_04_calli-tab.png";
import privateroom_calli_mo from "../images/privateroom/privateroom_04_calli-mo.png";

import privateroom_gallery_1_1_pc from "../images/privateroom/privateroom_gallery_1-1-pc.png";
import privateroom_gallery_1_2_pc from "../images/privateroom/privateroom_gallery_1-2-pc.png";
import privateroom_gallery_2_1_pc from "../images/privateroom/privateroom_gallery_2-1-pc.png";
import privateroom_gallery_2_2_pc from "../images/privateroom/privateroom_gallery_2-2-pc.png";
import privateroom_gallery_2_3_pc from "../images/privateroom/privateroom_gallery_2-3-pc.png";
import privateroom_gallery_3_1_pc from "../images/privateroom/privateroom_gallery_3-1-pc.png";
import privateroom_gallery_3_2_pc from "../images/privateroom/privateroom_gallery_3-2-pc.png";
import privateroom_gallery_4_1_pc from "../images/privateroom/privateroom_gallery_4-1-pc.png";
import privateroom_gallery_4_2_pc from "../images/privateroom/privateroom_gallery_4-2-pc.png";
import privateroom_gallery_4_3_pc from "../images/privateroom/privateroom_gallery_4-3-pc.png";

import privateroom_gallery_1_1_tab from "../images/privateroom/privateroom_gallery_1-1-tab.png";
import privateroom_gallery_1_2_tab from "../images/privateroom/privateroom_gallery_1-2-tab.png";
import privateroom_gallery_2_1_tab from "../images/privateroom/privateroom_gallery_2-1-tab.png";
import privateroom_gallery_2_2_tab from "../images/privateroom/privateroom_gallery_2-2-tab.png";
import privateroom_gallery_2_3_tab from "../images/privateroom/privateroom_gallery_2-3-tab.png";
import privateroom_gallery_3_1_tab from "../images/privateroom/privateroom_gallery_3-1-tab.png";
import privateroom_gallery_3_2_tab from "../images/privateroom/privateroom_gallery_3-2-tab.png";
import privateroom_gallery_4_1_tab from "../images/privateroom/privateroom_gallery_4-1-tab.png";
import privateroom_gallery_4_2_tab from "../images/privateroom/privateroom_gallery_4-2-tab.png";
import privateroom_gallery_4_3_tab from "../images/privateroom/privateroom_gallery_4-3-tab.png";

import privateroom_gallery_1_1_mo from "../images/privateroom/privateroom_gallery_1-1-mo.png";
import privateroom_gallery_1_2_mo from "../images/privateroom/privateroom_gallery_1-2-mo.png";
import privateroom_gallery_2_1_mo from "../images/privateroom/privateroom_gallery_2-1-mo.png";
import privateroom_gallery_2_2_mo from "../images/privateroom/privateroom_gallery_2-2-mo.png";
import privateroom_gallery_2_3_mo from "../images/privateroom/privateroom_gallery_2-3-mo.png";
import privateroom_gallery_3_1_mo from "../images/privateroom/privateroom_gallery_3-1-mo.png";
import privateroom_gallery_3_2_mo from "../images/privateroom/privateroom_gallery_3-2-mo.png";
import privateroom_gallery_4_1_mo from "../images/privateroom/privateroom_gallery_4-1-mo.png";
import privateroom_gallery_4_2_mo from "../images/privateroom/privateroom_gallery_4-2-mo.png";
import privateroom_gallery_4_3_mo from "../images/privateroom/privateroom_gallery_4-3-mo.png";


import privateroom_gallery_1_1_wide from "../images/privateroom/privateroom_gallery_1-1-wide.png";
import privateroom_gallery_1_2_wide from "../images/privateroom/privateroom_gallery_1-2-wide.png";
import privateroom_gallery_2_1_wide from "../images/privateroom/privateroom_gallery_2-1-wide.png";
import privateroom_gallery_2_2_wide from "../images/privateroom/privateroom_gallery_2-2-wide.png";
import privateroom_gallery_2_3_wide from "../images/privateroom/privateroom_gallery_2-3-wide.png";
import privateroom_gallery_3_1_wide from "../images/privateroom/privateroom_gallery_3-1-wide.png";
import privateroom_gallery_3_2_wide from "../images/privateroom/privateroom_gallery_3-2-wide.png";
import privateroom_gallery_3_3_wide from "../images/privateroom/privateroom_gallery_3-3-wide.png";
import privateroom_gallery_4_1_wide from "../images/privateroom/privateroom_gallery_4-1-wide.png";
import privateroom_gallery_4_2_wide from "../images/privateroom/privateroom_gallery_4-2-wide.png";
import privateroom_gallery_5_1_wide from "../images/privateroom/privateroom_gallery_5-1-wide.png";
import privateroom_gallery_5_2_wide from "../images/privateroom/privateroom_gallery_5-2-wide.png";
import privateroom_gallery_5_3_wide from "../images/privateroom/privateroom_gallery_5-3-wide.png";
import privateroom_gallery_5_4_wide from "../images/privateroom/privateroom_gallery_5-4-wide.png";


// ----------------------------------
//  Outro --------------------------------------
import outro_flow01_pc from "../images/outro/outro_flow01_pc.png";
import outro_flow02_pc from "../images/outro/outro_flow02_pc.png";
import outro_flow03_pc from "../images/outro/outro_flow03_pc.png";
import outro_flow04_pc from "../images/outro/outro_flow04_pc.png";
import outro_flow05_pc from "../images/outro/outro_flow05_pc.png";
import outro_flow06_pc from "../images/outro/outro_flow06_pc.png";
import outro_flow07_pc from "../images/outro/outro_flow07_pc.png";
import outro_flow08_pc from "../images/outro/outro_flow08_pc.png";
import outro_flow09_pc from "../images/outro/outro_flow09_pc.png";
import outro_flow10_pc from "../images/outro/outro_flow10_pc.png";
import outro_flow11_pc from "../images/outro/outro_flow11_pc.png";
import outro_flow12_pc from "../images/outro/outro_flow12_pc.png";
import outro_flow13_pc from "../images/outro/outro_flow13_pc.png";
import outro_flow14_pc from "../images/outro/outro_flow14_pc.png";
import outro_flow15_pc from "../images/outro/outro_flow15_pc.png";
import outro_flow16_pc from "../images/outro/outro_flow16_pc.png";
import outro_flow17_pc from "../images/outro/outro_flow17_pc.png";
import outro_flow18_pc from "../images/outro/outro_flow18_pc.png";

import outro_daejeon_pc from "../images/outro/outro_tit_DAEJEON_pc@2x.png";
import outro_daejeon_tab from "../images/outro/outro_tit_DAEJEON_tab.png";
import outro_daejeon_mo from "../images/outro/outro_tit_DAEJEON_mo.png";
import outro_star_pc from "../images/outro/outro_tit_STAR_pc@2x.png";
import outro_star_tab from "../images/outro/outro_tit_STAR_tab.png";
import outro_star_mo from "../images/outro/outro_tit_STAR_mo.png";
import outro_law_pc from "../images/outro/outro_tit_LAWFIRM_pc@2x.png";
import outro_law_tab from "../images/outro/outro_tit_LAWFIRM_tab.png";
import outro_law_mo from "../images/outro/outro_tit_LAWFIRM_mo.png";

import outro_community_pc from "../images/outro/outro_community_pc.png";
import outro_community_tab from "../images/outro/outro_community_tab.png";
import outro_community_mo from "../images/outro/outro_community_mo.png";
import outro_contact_pc from "../images/outro/outro_contact_pc.png";
import outro_contact_tab from "../images/outro/outro_contact_tab.png";
import outro_contact_mo from "../images/outro/outro_contact_mo.png";

export const lobbyKvData = {
  img: {
    pcSrc: lobby_kv_pc, tabSrc: lobby_kv_tab, moSrc: lobby_kv_mo,
    alt: 'Lobby KV',
  },
  title: {
    pcSrc: lobby_kv_title_pc, tabSrc: lobby_kv_title_tab, moSrc: lobby_kv_title_mo,
    alt: 'Lobby',
  },
  class: 'lobby',
}

export const loungeKvData = {
  img: {
    pcSrc: lounge_kv_pc, tabSrc: lounge_kv_tab, moSrc: lounge_kv_mo,
    alt: 'lounge KV',
  },
  title: {
    pcSrc: lounge_kv_title_pc, tabSrc: lounge_kv_title_tab, moSrc: lounge_kv_title_mo,
    alt: 'Lounge',
  },
  class: 'lounge',
}

export const privateroomKvData = {
  img: {
    pcSrc: privateroom_kv_pc, tabSrc: privateroom_kv_tab, moSrc: privateroom_kv_mo,
    alt: 'private room KV',
  },
  title: {
    pcSrc: privateroom_kv_title_pc, tabSrc: privateroom_kv_title_tab, moSrc: privateroom_kv_title_mo,
    alt: 'Private Room',
  },
  class: 'privateroom',
}

export const lobbyData = [
  {
    title: 'closet',
    titleImg: closet_title,
    mainDesc: '처음 마주하는 모던하고\n우아한 무드의 조화',
    mainImg: {
      pcSrc: closet_main_pc, tabSrc: closet_main_tab, moSrc: closet_main_mo,
      alt: 'closet image Main',
    },
    detailDesc: '편안함과 따뜻함이 어우러진 서비스의 시작',
    detailImgs: [
      {
        pcSrc: closet_01_pc, tabSrc: closet_01_tab, moSrc: closet_01_mo,
        alt: 'closet image',
      },
      {
        pcSrc: closet_02_pc, tabSrc: closet_02_tab, moSrc: closet_02_mo,
        alt: 'closet image',
      },
      {
        pcSrc: closet_03_pc, tabSrc: closet_03_tab, moSrc: closet_03_mo,
        alt: 'closet image',
      },
      {
        pcSrc: closet_04_pc, tabSrc: closet_04_tab, moSrc: closet_04_mo,
        alt: 'closet image',
      },
      {
        pcSrc: closet_05_pc, tabSrc: closet_05_tab, moSrc: closet_05_mo,
        alt: 'closet image',
      },
      {
        pcSrc: closet_06_pc, tabSrc: closet_06_tab, moSrc: closet_06_mo,
        alt: 'closet image',
      },
    ],
  },
  {
    title: 'vast',
    titleImg: vast_title,
    mainDesc: '트인 공간 속 끝없이 펼쳐지는\n파노라믹 디스플레이 공간',
    mainImg: {
      pcSrc: vast_main_pc, tabSrc: vast_main_tab, moSrc: vast_main_mo,
      alt: 'Vast image Main',
    },

    detailDesc: '선명한 디스플레이, 특별한 경험을 공유하는 순간',
    detailImgs: [
      {
        pcSrc: vast_01_pc, tabSrc: vast_01_tab, moSrc: vast_01_mo,
        alt: 'vast image',
      },
      {
        pcSrc: vast_02_pc, tabSrc: vast_02_tab, moSrc: vast_02_mo,
        alt: 'vast image',
      },
      {
        pcSrc: vast_03_pc, tabSrc: vast_03_tab, moSrc: vast_03_mo,
        alt: 'vast image',
      },
      {
        pcSrc: vast_04_pc, tabSrc: vast_04_tab, moSrc: vast_04_mo,
        alt: 'vast image',
      },
      {
        pcSrc: vast_05_pc, tabSrc: vast_05_tab, moSrc: vast_05_mo,
        alt: 'vast image',
      },
      {
        pcSrc: vast_06_pc, tabSrc: vast_06_tab, moSrc: vast_06_mo,
        alt: 'vast image',
      },
    ],
  },
  {
    title: 'tranquil',
    titleImg: tranquil_title,
    mainDesc: '대전분사무소만의 시그니처로\n오감을 사로잡는 경험',
    mainImg: {
      pcSrc: tranquil_main_pc, tabSrc: tranquil_main_tab, moSrc: tranquil_main_mo,
      alt: 'Tranquil image Main',
    },

    detailDesc: '선명한 디스플레이, 특별한 경험을 공유하는 순간',
    detailImgs: [
      {
        pcSrc: tranquil_01_pc, tabSrc: tranquil_01_tab, moSrc: tranquil_01_mo,
        alt: 'Tranquil image',
      },
      {
        pcSrc: tranquil_02_pc, tabSrc: tranquil_02_tab, moSrc: tranquil_02_mo,
        alt: 'Tranquil image',
      },
      {
        pcSrc: tranquil_03_pc, tabSrc: tranquil_03_tab, moSrc: tranquil_03_mo,
        alt: 'Tranquil image',
      },
      {
        pcSrc: tranquil_04_pc, tabSrc: tranquil_04_tab, moSrc: tranquil_04_mo,
        alt: 'Tranquil image',
      },
      {
        pcSrc: tranquil_05_pc, tabSrc: tranquil_05_tab, moSrc: tranquil_05_mo,
        alt: 'Tranquil image',
      },
      {
        pcSrc: tranquil_06_pc, tabSrc: tranquil_06_tab, moSrc: tranquil_06_mo,
        alt: 'Tranquil image',
      },
    ],
  },
]

export const loungeData = [
  {
    main: {
      title: 'Relaxed',
      img: lounge_relaxed,
      desc: '지친 마음과 몸을 위로받는 자연친화적인 공간',
    },
    contents:
      [{
        title_en: 'haven',
        title_kr: '안식처',
        desc: '복잡한 일상에서 벗어나\n잠시 여유로운 시간을 보내세요.',
        img:
          [{
            pcSrc: haven_01_pc, tabSrc: haven_01_tab, moSrc: haven_01_mo,
            alt: 'haven image',
          }, {
            pcSrc: haven_02_pc, tabSrc: haven_02_tab, moSrc: haven_02_mo,
            alt: 'haven image',
          }]
      }, {
        title_en: 'daisy',
        title_kr: '평화',
        desc: '고객님을 위해 준비된\n대전분사무소만의 작은 숲을 만나보세요.',
        img:
          [{
            pcSrc: daisy_01_pc, tabSrc: daisy_01_tab, moSrc: daisy_01_mo,
            alt: 'daisy image',
          }, {
            pcSrc: daisy_02_pc, tabSrc: daisy_02_tab, moSrc: daisy_02_mo,
            alt: 'daisy image',
          }]
      }]
  },
  {
    main: {
      title: 'Respectful',
      img: lounge_respectful,
      desc: '눈을 맞추고 고객의 이야기를 경청하는 공간',
    },
    contents:
      [{
        title_en: 'sage',
        title_kr: '현명한',
        desc: '지친 마음과 피로를 완화하는\n편안한 휴식을 선사합니다.',
        img:
          [{
            pcSrc: sage_01_pc, tabSrc: sage_01_tab, moSrc: sage_01_mo,
            alt: 'Sage image',
          }, {
            pcSrc: sage_02_pc, tabSrc: sage_02_tab, moSrc: sage_02_mo,
            alt: 'Sage image',
          }]
      }, {
        title_en: 'aria',
        title_kr: '선율의 독창',
        desc: '안락한 휴식 속 고즈넉한 선율과\n감성적인 여유를 누려보세요.',
        img:
          [{
            pcSrc: aria_01_pc, tabSrc: aria_01_tab, moSrc: aria_01_mo,
            alt: 'daisy image',
          }, {
            pcSrc: aria_02_pc, tabSrc: aria_02_tab, moSrc: aria_02_mo,
            alt: 'daisy image',
          }]
      }]
  },
  {
    main: {
      title: 'Honest',
      img: lounge_honest,
      desc: '진실함과 정직함을 상징하는 순백의 공간',
    },
    contents:
      [{
        title_en: 'ethereal',
        title_kr: '천상의',
        desc: '빛으로 둘러싸인\n천상의 아름다움을 경험하세요.',
        img:
          [{
            pcSrc: ethereal_01_pc, tabSrc: ethereal_01_tab, moSrc: ethereal_01_mo,
            alt: 'Sage image',
          }, {
            pcSrc: ethereal_02_pc, tabSrc: ethereal_02_tab, moSrc: ethereal_02_mo,
            alt: 'Sage image',
          }]
      }, {
        title_en: 'elysium',
        title_kr: '이상향',
        desc: '신뢰를 바탕으로 이어진\n발자취를 확인하세요.',
        img:
          [{
            pcSrc: elysium_01_pc, tabSrc: elysium_01_tab, moSrc: elysium_01_mo,
            alt: 'daisy image',
          }, {
            pcSrc: elysium_02_pc, tabSrc: elysium_02_tab, moSrc: elysium_02_mo,
            alt: 'daisy image',
          }]
      }]
  }
]

export const privateRoomData = {
  titleImg: {
    pcSrc: privateroom_title_pc, tabSrc: privateroom_title_tab, moSrc: privateroom_title_mo,
    alt: 'ECLIPSE & TWILIGHT',
  },
  inner : [
    {
      calli: {
        pcSrc: privateroom_calli_pc,
        tabSrc: privateroom_calli_tab,
        moSrc: privateroom_calli_mo,
      },
      img1: {
        pcSrc: privateroom_01_pc, tabSrc: privateroom_01_tab, moSrc: privateroom_01_mo,
        alt: '1',
      },
      img2: {
        pcSrc: privateroom_02_pc, tabSrc: privateroom_02_tab, moSrc: privateroom_02_mo,
        alt: '2',
      },
      img3: {
        pcSrc: privateroom_03_pc, tabSrc: privateroom_03_tab, moSrc: privateroom_03_mo,
        alt: '3',
      },
      img4: {
        pcSrc: privateroom_04_pc, tabSrc: privateroom_04_tab, moSrc: privateroom_04_mo,
        alt: '4',
      },
      img5: {
        pcSrc: privateroom_05_pc, tabSrc: privateroom_05_tab, moSrc: privateroom_05_mo,
        alt: '5',
      },
      img6: {
        pcSrc: privateroom_06_pc, tabSrc: privateroom_06_tab, moSrc: privateroom_06_mo,
        alt: '6',
      },
      img7: {
        pcSrc: privateroom_07_pc, tabSrc: privateroom_07_tab, moSrc: privateroom_07_mo,
        alt: '7',
      },
    },
    {
      img1_1: {
        pcSrc: privateroom_gallery_1_1_pc, tabSrc: privateroom_gallery_1_1_tab, moSrc: privateroom_gallery_1_1_mo,
        alt: '1',
      },
      img1_2: {
        pcSrc: privateroom_gallery_1_2_pc, tabSrc: privateroom_gallery_1_2_tab, moSrc: privateroom_gallery_1_2_mo,
        alt: '1',
      },
      img2_1: {
        pcSrc: privateroom_gallery_2_1_pc, tabSrc: privateroom_gallery_2_1_tab, moSrc: privateroom_gallery_2_1_mo,
        alt: '1',
      },
      img2_2: {
        pcSrc: privateroom_gallery_2_2_pc, tabSrc: privateroom_gallery_2_2_tab, moSrc: privateroom_gallery_2_2_mo,
        alt: '1',
      },
      img2_3: {
        pcSrc: privateroom_gallery_2_3_pc, tabSrc: privateroom_gallery_2_3_tab, moSrc: privateroom_gallery_2_3_mo,
        alt: '1',
      },
      img3_1: {
        pcSrc: privateroom_gallery_3_1_pc, tabSrc: privateroom_gallery_3_1_tab, moSrc: privateroom_gallery_3_1_mo,
        alt: '1',
      },
      img3_2: {
        pcSrc: privateroom_gallery_3_2_pc, tabSrc: privateroom_gallery_3_2_tab, moSrc: privateroom_gallery_3_2_mo,
        alt: '1',
      },
      img4_1: {
        pcSrc: privateroom_gallery_4_1_pc, tabSrc: privateroom_gallery_4_1_tab, moSrc: privateroom_gallery_4_1_mo,
        alt: '1',
      },
      img4_2: {
        pcSrc: privateroom_gallery_4_2_pc, tabSrc: privateroom_gallery_4_2_tab, moSrc: privateroom_gallery_4_2_mo,
        alt: '1',
      },
      img4_3: {
        pcSrc: privateroom_gallery_4_3_pc, tabSrc: privateroom_gallery_4_3_tab, moSrc: privateroom_gallery_4_3_mo,
        alt: '1',
      },
    }
  ],
  wide:   {
    img1_1: privateroom_gallery_1_1_wide,
    img1_2: privateroom_gallery_1_2_wide,
    img2_1: privateroom_gallery_2_1_wide,
    img2_2: privateroom_gallery_2_2_wide,
    img2_3: privateroom_gallery_2_3_wide,
    img3_1: privateroom_gallery_3_1_wide,
    img3_2: privateroom_gallery_3_2_wide,
    img3_3: privateroom_gallery_3_3_wide,
    img4_1: privateroom_gallery_4_1_wide,
    img4_2: privateroom_gallery_4_2_wide,
    img5_1: privateroom_gallery_5_1_wide,
    img5_2: privateroom_gallery_5_2_wide,
    img5_3: privateroom_gallery_5_3_wide,
    img5_4: privateroom_gallery_5_4_wide,
  }
}

export const outroDate = {
  outroTitImg : [
    {
      pcSrc:outro_star_pc,
      tabSrc:outro_star_tab,
      moSrc:outro_star_mo,
      alt:'star'

    },
    {
      pcSrc:outro_law_pc,
      tabSrc:outro_law_tab,
      moSrc:outro_law_mo,
      alt:'law firm'

    },{
      pcSrc:outro_daejeon_pc,
      tabSrc:outro_daejeon_tab,
      moSrc:outro_daejeon_mo,
      alt:'daejeon'
    }

  ],
  outroflowImg : [
      {
        pcSrc:outro_flow01_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow02_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow03_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow04_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow05_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow06_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow07_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow08_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow09_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow10_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow11_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow12_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow13_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow14_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow15_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow16_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow17_pc,
        alt:'outro image'
      },
      {
        pcSrc:outro_flow18_pc,
        alt:'outro image'
      },
  ],
  outroLinkImg :[
    {
      pcSrc:outro_community_pc,
      tabSrc:outro_community_tab,
      moSrc:outro_community_mo,
      alt:'community page image'

    },{
      pcSrc:outro_contact_pc,
      tabSrc:outro_contact_tab,
      moSrc:outro_contact_mo,
      alt:'contact page image'

    }
  ]

}

